/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-bitwise */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, {
  useContext, useEffect, useMemo, useState,
} from 'react';
import moment from 'moment-timezone';
import {
  Search, ChevronsUpDown, ChevronUp, ChevronDown, ChevronLeft, ChevronRight,
  Camera, MapPin, X, RefreshCw,
} from 'lucide-react';
import CircularProgress from '@mui/material/CircularProgress';
import { Modal, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { Navbar, Sidebar } from '../../components';
import { UserContext } from '../../contexts/User';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import { NotificationContext } from '../../contexts/Notification';
import RowActionMenu from '../../components/RowActionMenu';

const AVATAR_PALETTE = [
  { bg: '#fdebe6', fg: '#b94f3c' },
  { bg: '#fde6d2', fg: '#F19235' },
  { bg: '#eef5ea', fg: '#53A551' },
  { bg: '#e8eef7', fg: '#4062E5' },
];

function avatarColors(key) {
  const str = String(key || '');
  let h = 0;
  for (let i = 0; i < str.length; i += 1) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return AVATAR_PALETTE[h % AVATAR_PALETTE.length];
}

function initialsFrom(firstName, lastName, email) {
  if (firstName && lastName) return `${firstName[0]}${lastName[0]}`.toUpperCase();
  if (email) return email.slice(0, 2).toUpperCase();
  return '?';
}

function ThreatPill({ count }) {
  if (!count) {
    return (
      <span className="inline-flex items-center justify-center px-3 py-0.5 rounded-full text-[11px] font-semibold bg-[#eef5ea] text-[#53A551]">
        None
      </span>
    );
  }
  return (
    <span className="inline-flex items-center justify-center px-3 py-0.5 rounded-full text-[11px] font-semibold bg-[#fdebe6] text-[#b94f3c] whitespace-nowrap">
      {count}
      {' '}
      Unresolved
    </span>
  );
}

function RowActions({ disabled, onViewIssues, onResolveAll }) {
  // Shared design-system menu. No destructive items here, so nothing is red.
  return (
    <RowActionMenu
      orientation="vertical"
      iconSize={16}
      ariaLabel="Open actions"
      triggerClassName="p-1 rounded hover:bg-surface-1 text-ink-500 transition bg-transparent border-0"
      items={[
        { label: 'View Issues', onClick: onViewIssues, disabled },
        { label: 'Resolve All Open Issues', onClick: onResolveAll, disabled },
      ]}
    />
  );
}

function SortIcon({ active, dir }) {
  if (!active) return <ChevronsUpDown size={12} className="text-ink-500" />;
  return dir === 'asc' ? <ChevronUp size={12} /> : <ChevronDown size={12} />;
}

function InlinePagination({
  page, pageSize, total, onPageChange, onPageSizeChange,
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(total, page * pageSize);
  const pages = useMemo(() => {
    const max = 5;
    if (totalPages <= max) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const half = Math.floor(max / 2);
    let from = Math.max(1, page - half);
    let to = from + max - 1;
    if (to > totalPages) {
      to = totalPages;
      from = totalPages - max + 1;
    }
    return Array.from({ length: max }, (_, i) => from + i);
  }, [page, totalPages]);

  return (
    <div
      className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-5 py-3"
      style={{ borderTop: '1px solid #f1f2f5' }}
    >
      <div className="flex items-center gap-1 flex-wrap">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page === 1}
          aria-label="Previous page"
          className="w-8 h-8 inline-flex items-center justify-center rounded-[6px] text-ink-900 hover:bg-surface-1 disabled:opacity-40 disabled:cursor-not-allowed transition"
        >
          <ChevronLeft size={16} />
        </button>
        {pages.map((p) => {
          const active = p === page;
          return (
            <button
              key={p}
              type="button"
              onClick={() => onPageChange(p)}
              className={`min-w-[32px] h-8 px-2 inline-flex items-center justify-center rounded-[6px] text-sm font-medium transition ${
                active ? 'bg-brand-700 text-white' : 'text-ink-900 hover:bg-surface-1'
              }`}
            >
              {p}
            </button>
          );
        })}
        <button
          type="button"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page === totalPages || total === 0}
          aria-label="Next page"
          className="w-8 h-8 inline-flex items-center justify-center rounded-[6px] text-ink-900 hover:bg-surface-1 disabled:opacity-40 disabled:cursor-not-allowed transition"
        >
          <ChevronRight size={16} />
        </button>
      </div>
      <div className="flex items-center gap-3 text-sm text-ink-900 flex-wrap">
        <span>Rows Per Page:</span>
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="px-2 py-1 border border-rule rounded-[6px] text-sm bg-white text-ink-900 focus:outline-none focus:border-brand-500"
          style={{ borderStyle: 'solid' }}
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
        <span className="text-ink-500">|</span>
        <span className="tabular-nums">
          {start}
          -
          {end}
          {' '}
          of
          {' '}
          {total}
        </span>
      </div>
    </div>
  );
}

function IssuesModal({
  member, workspaceId, onClose, onResolveAll, onChanged,
}) {
  const { displayNotification } = useContext(NotificationContext);
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [resolvingId, setResolvingId] = useState(null);

  const firstName = member?.user?.firstName || '';
  const lastName = member?.user?.lastName || '';
  const fullName = `${firstName || ''} ${lastName || ''}`.trim() || (member?.user?.email || '—');
  const c = avatarColors(member?.user?.email || member.id);

  const load = async () => {
    setLoading(true);
    const url = API.WORKSPACE.memberInsiderThreats(workspaceId, member.id);
    // The endpoint filters by an exact `status`, so fetch both and merge to
    // show resolved + unresolved issues (matching the prototype).
    const [unres, res] = await Promise.all([
      sendRequest({ method: 'get', url, params: { status: 'Unresolved' } }),
      sendRequest({ method: 'get', url, params: { status: 'Resolved' } }),
    ]);
    const all = [
      ...(unres.success ? unres.data?.violations || [] : []),
      ...(res.success ? res.data?.violations || [] : []),
    ].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    setIssues(all);
    setLoading(false);
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [member.id]);

  const resolveOne = async (v) => {
    setResolvingId(v.id);
    const r = await sendRequest({
      method: 'put',
      url: API.WORKSPACE.resolveThreat(v.id),
      params: { type: v.type },
    });
    setResolvingId(null);
    if (r.success) {
      displayNotification({ message: 'Issue resolved.', severity: 'success' });
      await load();
      onChanged?.();
    } else {
      displayNotification({ message: 'There was an issue resolving this. Please try again.', severity: 'error' });
    }
  };

  const unresolved = issues.filter((i) => i.status !== 'Resolved').length;

  return (
    <Modal open onClose={onClose} className="flex-row align-c jstfy-c">
      <Box style={{
        width: 512,
        maxWidth: 'calc(100% - 32px)',
        maxHeight: '90vh',
        overflowY: 'auto',
        padding: 24,
        background: '#fff',
        borderRadius: 12,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      }}
      >
        <button
          type="button"
          aria-label="Close"
          onClick={onClose}
          className="absolute top-4 right-4 bg-transparent border-0 p-0 text-ink-500 opacity-70 hover:opacity-100 transition-opacity"
        >
          <X size={18} />
        </button>
        <h5 className="text-lg font-semibold text-ink-900">Insider Threat Issues</h5>

        <div className="flex items-center gap-3 px-3 py-2 rounded-[8px] bg-surface-page border border-surface-1">
          <div
            className="w-9 h-9 rounded-full flex items-center justify-center text-xs font-semibold flex-shrink-0"
            style={{ backgroundColor: c.bg, color: c.fg }}
          >
            {initialsFrom(firstName, lastName, member?.user?.email)}
          </div>
          <div className="min-w-0">
            <p className="text-base leading-5 text-ink-900 font-medium truncate mb-0">{fullName}</p>
            <p className="text-[11px] leading-4 text-ink-500 truncate mb-0 mt-1">{member?.user?.email}</p>
          </div>
          <div className="ml-auto">
            <ThreatPill count={unresolved} />
          </div>
        </div>

        <div className="max-h-[50vh] overflow-y-auto divide-y divide-surface-1 border border-surface-1 rounded-[8px]">
          {loading && (
            <div className="px-3 py-10 flex items-center justify-center">
              <CircularProgress size={22} sx={{ color: 'inherit' }} />
            </div>
          )}
          {!loading && issues.length === 0 && (
            <div className="px-3 py-8 text-center text-sm text-ink-500">No issues found.</div>
          )}
          {!loading && issues.map((v) => {
            const isWebcam = v.type !== 'Location';
            const Icon = isWebcam ? Camera : MapPin;
            const description = `Physical Safeguard Breach - ${v.type === 'Location' ? 'Location' : `Webcam ${v.type}`}`;
            const resolved = v.status === 'Resolved';
            return (
              <div key={`${v.type}-${v.id}`} className="flex items-start gap-3 px-3 py-3">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
                    isWebcam ? 'bg-[#fde6d2] text-[#F19235]' : 'bg-[#e8eef7] text-brand-500'
                  }`}
                >
                  <Icon size={14} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm leading-5 text-ink-900 font-medium mb-0">{description}</p>
                  <p className="text-[11px] leading-4 text-ink-500 mt-1 mb-0">
                    {isWebcam ? 'Webcam Violation' : 'Location Violation'}
                    {' · '}
                    {moment(v.createdAt).format('MM/DD/YYYY')}
                    {' · '}
                    {moment(v.createdAt).format('hh:mm A')}
                  </p>
                </div>
                {resolved ? (
                  <span className="inline-flex items-center justify-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-[#eef5ea] text-[#53A551] flex-shrink-0">
                    Resolved
                  </span>
                ) : (
                  <button
                    type="button"
                    onClick={() => resolveOne(v)}
                    disabled={resolvingId === v.id}
                    className="px-3 py-1 border border-rule rounded-[6px] text-xs font-semibold text-ink-900 bg-white hover:border-[#53A551] hover:text-[#53A551] disabled:opacity-50 transition flex-shrink-0"
                  >
                    {resolvingId === v.id ? 'Resolving...' : 'Resolve'}
                  </button>
                )}
              </div>
            );
          })}
        </div>

        <div className="flex items-center justify-start gap-2">
          {unresolved > 0 && (
            <button
              type="button"
              onClick={onResolveAll}
              className="inline-flex items-center justify-center px-4 py-2 bg-[#53A551] text-white rounded-[8px] text-sm font-medium hover:bg-[#458a44] transition"
            >
              Resolve All
            </button>
          )}
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center px-4 py-2 border border-rule rounded-[8px] text-sm font-medium text-ink-900 bg-white hover:bg-gray-50 transition"
          >
            Close
          </button>
        </div>
      </Box>
    </Modal>
  );
}

function ResolveAllDialog({ onCancel, onConfirm, isResolving }) {
  return (
    <Modal open onClose={onCancel} className="flex-row align-c jstfy-c">
      <Box style={{
        width: 448,
        maxWidth: 'calc(100% - 32px)',
        padding: 24,
        background: '#fff',
        borderRadius: 12,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      }}
      >
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#e8eef7] text-brand-500">
          <RefreshCw size={22} />
        </div>
        <h5 className="text-lg font-semibold leading-none text-ink-900 mb-0">
          Are you sure you want to resolve all issues?
        </h5>
        <p className="text-sm text-ink-500 leading-relaxed mb-0">
          This action cannot be undone and will mark all issues as resolved.
          Please confirm your decision below.
        </p>
        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center justify-center px-4 py-2 border border-rule rounded-[8px] text-sm font-medium text-ink-900 bg-white hover:bg-gray-50 transition"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isResolving}
            className="inline-flex items-center justify-center px-4 py-2 bg-[#53A551] text-white rounded-[8px] text-sm font-medium hover:bg-[#458a44] disabled:opacity-50 transition"
          >
            {isResolving ? 'Resolving...' : 'Resolve All'}
          </button>
        </div>
      </Box>
    </Modal>
  );
}

// Small pages keep each request light enough for the CURRENT backend (which
// still hydrates every violation row) to avoid timeouts. Once the count-based
// backend change is deployed, any page size is cheap and this can be collapsed
// back into a single request.
const PAGE_FETCH_SIZE = 10;
const FETCH_CONCURRENCY = 3;

function InsiderThreats() {
  const { activeWorkspace } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);
  const [allMembers, setAllMembers] = useState([]);
  const [isResolvingAll, setIsResolvingAll] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedMember, setSelectedMember] = useState(null);
  const [viewTarget, setViewTarget] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortKey, setSortKey] = useState('name');
  const [sortDir, setSortDir] = useState('asc');

  // Load every member in small pages (fetched in bounded-concurrency batches),
  // then search / sort / paginate entirely in the browser. Each page retries
  // once, and a failed page never blanks the table — so a slow heavy page on
  // the current backend degrades gracefully instead of wiping the list.
  const fetchPage = (url, page) => sendRequest({
    method: 'get',
    url,
    params: {
      name: '', sortKey: 'name', sortOrder: 'ASC', pageSize: PAGE_FETCH_SIZE, page,
    },
    // Heavy pages (a member can have 700+ violations) are slow on the current
    // backend; give them headroom rather than dropping them at 30s.
    timeout: 60000,
  });

  const fetchPageWithRetry = async (url, page) => {
    const r = await fetchPage(url, page);
    if (r.success) return r;
    // eslint-disable-next-line no-console
    console.warn(`Insider Threats: page ${page} failed (status ${r.status}), retrying once`);
    return fetchPage(url, page);
  };

  const fetchAllMembers = async () => {
    if (!activeWorkspace?.id) return;
    setIsLoading(true);
    const url = API.WORKSPACE.membersInsiderThreats(activeWorkspace.id);
    const first = await fetchPageWithRetry(url, 1);
    if (!first.success) {
      // eslint-disable-next-line no-console
      console.warn('Insider Threats: first page failed', first);
      setIsLoading(false);
      return;
    }
    // Show the first page right away, then append later pages as each arrives —
    // a slow/failed heavy page no longer holds up (or wipes) the rest.
    setAllMembers(first.data?.members || []);
    setIsLoading(false);
    const total = first.data?.totalCounts ?? (first.data?.members || []).length;
    const totalPages = Math.max(1, Math.ceil(total / PAGE_FETCH_SIZE));
    const remaining = Array.from({ length: totalPages - 1 }, (_, i) => i + 2);
    for (let i = 0; i < remaining.length; i += FETCH_CONCURRENCY) {
      const batch = remaining.slice(i, i + FETCH_CONCURRENCY);
      // eslint-disable-next-line no-await-in-loop
      await Promise.all(batch.map(async (p) => {
        const r = await fetchPageWithRetry(url, p);
        if (r.success) {
          const ms = r.data?.members || [];
          if (ms.length) setAllMembers((prev) => [...prev, ...ms]);
        } else {
          // eslint-disable-next-line no-console
          console.warn(`Insider Threats: page ${p} dropped (status ${r.status})`);
        }
      }));
    }
  };

  const memberNameOf = (m) => {
    const fn = m?.user?.firstName || '';
    const ln = m?.user?.lastName || '';
    return `${fn || ''} ${ln || ''}`.trim() || (m?.user?.email || '');
  };

  const resolveAll = async () => {
    if (!selectedMember) return;
    setIsResolvingAll(true);
    const r = await sendRequest({
      method: 'put',
      url: API.WORKSPACE.resolveMemberThreats(activeWorkspace.id, selectedMember.id),
    });
    setIsResolvingAll(false);
    setIsModalOpen(false);
    if (r.success) {
      displayNotification({
        message: `All open issues resolved for ${memberNameOf(selectedMember)}.`,
        severity: 'success',
      });
      await fetchAllMembers();
    } else {
      displayNotification({
        message: 'There was an issue resolving these issues. Please try again.',
        severity: 'error',
      });
    }
  };

  useEffect(() => {
    fetchAllMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeWorkspace?.id]);

  // Backend returns unresolved-violation counts directly; fall back to array
  // length so this also works against an older backend during a deploy window.
  const threatCount = (m) => {
    const wc = m?.webcamViolationCount ?? m?.webcamViolations?.length ?? 0;
    const loc = m?.locationViolationCount ?? m?.locationViolations?.length ?? 0;
    return Number(wc) + Number(loc);
  };

  // Search across ALL members (name + email)
  const filtered = useMemo(() => {
    const q = searchInput.trim().toLowerCase();
    if (!q) return allMembers;
    return allMembers.filter((m) => memberNameOf(m).toLowerCase().includes(q)
      || (m?.user?.email || '').toLowerCase().includes(q));
  }, [allMembers, searchInput]);

  // Sort across ALL filtered members
  const sorted = useMemo(() => {
    const arr = [...filtered];
    arr.sort((a, b) => {
      let av;
      let bv;
      if (sortKey === 'threats') {
        av = threatCount(a); bv = threatCount(b);
      } else if (sortKey === 'issueDate') {
        av = a?.latestViolationDate ? new Date(a.latestViolationDate).getTime() : 0;
        bv = b?.latestViolationDate ? new Date(b.latestViolationDate).getTime() : 0;
      } else {
        av = memberNameOf(a).toLowerCase(); bv = memberNameOf(b).toLowerCase();
      }
      const cmp = av < bv ? -1 : av > bv ? 1 : 0;
      return sortDir === 'asc' ? cmp : -cmp;
    });
    return arr;
  }, [filtered, sortKey, sortDir]);

  const totalCounts = filtered.length;
  const displayedMembers = useMemo(
    () => sorted.slice((currentPage - 1) * pageSize, currentPage * pageSize),
    [sorted, currentPage, pageSize],
  );

  // Reset to first page whenever the result set changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchInput, sortKey, sortDir, pageSize]);

  const handleSearchChange = (e) => setSearchInput(e.target.value);
  const handlePageChange = (next) => setCurrentPage(next);
  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const toggleSort = (key) => {
    if (key === sortKey) {
      setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="screen-wrapper">
        <div className="screen-header">
          <div className="flex flex-col gap-3 mb-4 sm:flex-row sm:items-start sm:justify-between">
            <div className="min-w-0 flex-1">
              <h1 className="font-bold text-ink-900 leading-tight truncate text-2xl lg:text-[32px] lg:leading-10" data-tour="insider-threats">
                Insider Threats
              </h1>
              <p className="text-sm text-ink-500 mt-1">
                View location and webcam audit violations
              </p>
            </div>
          </div>

          <div
            className="rounded-xl bg-white shadow-[0_1px_2px_rgba(14,30,64,0.04)] overflow-hidden"
            style={{ border: '1px solid #e8eaf0' }}
          >
            <div
              className="px-5 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
              style={{ borderBottom: '1px solid #f1f2f5' }}
            >
              <h3 className="text-base font-semibold text-ink-900">
                All Users (
                {totalCounts}
                )
              </h3>
              <div className="relative w-full sm:w-80" style={{ height: '40px' }}>
                <Search
                  size={14}
                  className="text-ink-500 pointer-events-none"
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 1,
                  }}
                />
                <input
                  type="text"
                  value={searchInput}
                  onChange={handleSearchChange}
                  placeholder="Search for user"
                  className="w-full rounded-[8px] bg-white text-ink-900 placeholder:text-ink-500 focus:outline-none"
                  style={{
                    height: '40px',
                    paddingLeft: '36px',
                    paddingRight: '12px',
                    fontSize: '14px',
                    lineHeight: '20px',
                    border: '1px solid #e0e1e6',
                    boxSizing: 'border-box',
                  }}
                />
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full min-w-[720px]">
                <thead className="bg-surface-page" style={{ borderBottom: '1px solid #f1f2f5' }}>
                  <tr className="text-left text-[11px] text-ink-500 uppercase tracking-wider">
                    <th className="px-5 py-3 font-semibold">
                      <button
                        type="button"
                        onClick={() => toggleSort('name')}
                        className={`inline-flex items-center gap-1 text-[11px] uppercase tracking-wider font-semibold transition ${sortKey === 'name' ? 'text-ink-900' : 'hover:text-ink-900'}`}
                      >
                        User
                        {' '}
                        <SortIcon active={sortKey === 'name'} dir={sortDir} />
                      </button>
                    </th>
                    <th className="px-5 py-3 font-semibold">
                      <button
                        type="button"
                        onClick={() => toggleSort('threats')}
                        className={`inline-flex items-center gap-1 text-[11px] uppercase tracking-wider font-semibold transition ${sortKey === 'threats' ? 'text-ink-900' : 'hover:text-ink-900'}`}
                      >
                        Threats
                        {' '}
                        <SortIcon active={sortKey === 'threats'} dir={sortDir} />
                      </button>
                    </th>
                    <th className="px-5 py-3 font-semibold">
                      <button
                        type="button"
                        onClick={() => toggleSort('issueDate')}
                        className={`inline-flex items-center gap-1 text-[11px] uppercase tracking-wider font-semibold transition ${sortKey === 'issueDate' ? 'text-ink-900' : 'hover:text-ink-900'}`}
                      >
                        Last Issue Date
                        {' '}
                        <SortIcon active={sortKey === 'issueDate'} dir={sortDir} />
                      </button>
                    </th>
                    <th className="px-5 py-3 w-12" />
                  </tr>
                </thead>
                <tbody className="divide-y divide-surface-1">
                  {isLoading && (
                    <tr>
                      <td colSpan={4} className="px-5 py-12 text-center">
                        <CircularProgress size={24} sx={{ color: 'inherit' }} />
                      </td>
                    </tr>
                  )}

                  {!isLoading && totalCounts === 0 && (
                    <tr>
                      <td colSpan={4} className="px-5 py-8 text-center text-sm text-ink-500">
                        No users found.
                      </td>
                    </tr>
                  )}

                  {!isLoading && displayedMembers.map((m) => {
                    const totalViolations = threatCount(m);
                    const firstName = m?.user?.firstName || '';
                    const lastName = m?.user?.lastName || '';
                    const fullName = `${firstName || ''} ${lastName || ''}`.trim() || (m?.user?.email || '—');
                    const c = avatarColors(m?.user?.email || m.id);
                    return (
                      <tr key={m.id} className="text-sm hover:bg-surface-page transition">
                        <td className="px-5 py-3">
                          <div className="flex items-center gap-3 min-w-0">
                            <div
                              className="w-8 h-8 rounded-full flex items-center justify-center text-[11px] font-semibold flex-shrink-0"
                              style={{ backgroundColor: c.bg, color: c.fg }}
                            >
                              {initialsFrom(firstName, lastName, m?.user?.email)}
                            </div>
                            <div className="min-w-0">
                              <Link
                                to={`/profile/${m.id}?from=/insiderThreats`}
                                className="block text-ink-900 truncate mb-0 hover:text-brand-700 hover:underline"
                                style={{ fontSize: '14px', fontWeight: 500, lineHeight: '20px' }}
                              >
                                {fullName}
                              </Link>
                              <p
                                className="text-ink-500 truncate mb-0"
                                style={{ fontSize: '11px', fontWeight: 400, lineHeight: '16px' }}
                              >
                                {m?.user?.email}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td className="px-5 py-3">
                          <ThreatPill count={totalViolations} />
                        </td>
                        <td className="px-5 py-3 text-ink-900 tabular-nums whitespace-nowrap">
                          {m?.latestViolationDate
                            ? moment(m.latestViolationDate).format('hh:mm A · MM/DD/YYYY')
                            : 'None'}
                        </td>
                        <td className="px-5 py-3">
                          <div className="flex justify-end">
                            <RowActions
                              disabled={totalViolations === 0}
                              onViewIssues={() => setViewTarget(m)}
                              onResolveAll={() => {
                                setSelectedMember(m);
                                setIsModalOpen(true);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {!isLoading && totalCounts > 0 && (
              <InlinePagination
                page={currentPage}
                pageSize={pageSize}
                total={totalCounts}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
              />
            )}
          </div>

          {viewTarget && (
            <IssuesModal
              member={viewTarget}
              workspaceId={activeWorkspace.id}
              onClose={() => setViewTarget(null)}
              onChanged={() => fetchAllMembers()}
              onResolveAll={() => {
                setSelectedMember(viewTarget);
                setViewTarget(null);
                setIsModalOpen(true);
              }}
            />
          )}

          {isModalOpen && (
            <ResolveAllDialog
              isResolving={isResolvingAll}
              onCancel={() => setIsModalOpen(false)}
              onConfirm={() => resolveAll()}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default InsiderThreats;
